import React, { useState, useEffect } from "react";
import { Button, Collapse } from "reactstrap";
import classnames from "classnames";
import { createSelector } from "reselect";
// hooks
import { useRedux } from "../../../hooks/index";

// actions
import { getSettings, updateSettings } from "../../../redux/actions";

// constants
import { SETTINGS_COLLAPSES } from "../../../constants";

// interface
import { SettingsTypes } from "../../../data/settings";

// components
import Loader from "../../../components/Loader";
import AppSimpleBar from "../../../components/AppSimpleBar";
import UserCoverImage from "./UserCoverImage";
import UserProfile from "./UserProfile";
import PersonalInfo from "./PersonalInfo";
import ThemeSettings from "./ThemeSettings";
import Privacy from "./Privacy";
import Security from "./Security";
import Help from "./Help";
import DisplaySetting from "./DisplaySetting";
import SystemSetting from "./SystemSetting";
import NotificationSetting from "./NotificationSetting";
import { UserTypes } from "api";
import DataSetting from "./DataSetting";

interface CollapseItemTypes {
  value:
  | SETTINGS_COLLAPSES.DISPLAY
  | SETTINGS_COLLAPSES.PROFILE
  | SETTINGS_COLLAPSES.HELP
  | SETTINGS_COLLAPSES.PRIVACY
  | SETTINGS_COLLAPSES.SECURITY
  | SETTINGS_COLLAPSES.THEME
  | SETTINGS_COLLAPSES.SYSTEM
  | SETTINGS_COLLAPSES.NOTIFICATION_SETTING
  | SETTINGS_COLLAPSES.DATA;
  label: string;
  icon: string;
  component: any;
}

interface AccordianItemProps {
  item: CollapseItemTypes;
  onChange: (
    id:
      | null
      | SETTINGS_COLLAPSES.DISPLAY
      | SETTINGS_COLLAPSES.PROFILE
      | SETTINGS_COLLAPSES.HELP
      | SETTINGS_COLLAPSES.PRIVACY
      | SETTINGS_COLLAPSES.SECURITY
      | SETTINGS_COLLAPSES.THEME
      | SETTINGS_COLLAPSES.SYSTEM
      | SETTINGS_COLLAPSES.NOTIFICATION_SETTING
      | SETTINGS_COLLAPSES.DATA
  ) => void;
  selectedMenu:
  | null
  | SETTINGS_COLLAPSES.DISPLAY
  | SETTINGS_COLLAPSES.PROFILE
  | SETTINGS_COLLAPSES.HELP
  | SETTINGS_COLLAPSES.PRIVACY
  | SETTINGS_COLLAPSES.SECURITY
  | SETTINGS_COLLAPSES.THEME
  | SETTINGS_COLLAPSES.SYSTEM
  | SETTINGS_COLLAPSES.NOTIFICATION_SETTING
  | SETTINGS_COLLAPSES.DATA
  ;
}
const AccordianItem = ({
  item,
  selectedMenu,
  onChange,
}: AccordianItemProps) => {
  //const isOpen: boolean = selectedMenu && selectedMenu === item.value ? true : false;
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const toggleCollapse = () => {
    // if (isOpen) {
    //   onChange(null);
    // } else {
    //   onChange(item.value);
    // }
    setIsOpen((prev) => !prev);
  };
  return (
    <div className="accordion-item">
      <div className="accordion-header" id="headerpersonalinfo">
        <Button
          color="none"
          className={classnames(
            "accordion-button",
            "font-size-16",
            "fw-medium",
            { collapsed: !isOpen }
          )}
          onClick={toggleCollapse}
          type="button"
        >
          <i className={classnames("text-muted", "me-3", item.icon)}></i>{" "}
          {item.label}
        </Button>
      </div>
      <Collapse
        isOpen={isOpen}
        id="personalinfo"
        className="accordion-collapse"
      >
        {item.component}
      </Collapse>
    </div>
  );
};
interface IndexProps { }
const Index = (props: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();


  const errorData = createSelector(
    (state: any) => state.Settings,
    (state: any) => state.Profile,
    (state, pf) => ({
      settingsData: state.settings,
      getSettingsLoading: state.getSettingsLoading,
      isSettingsFetched: state.isSettingsFetched,
      userType: pf.profileDetails?.basicDetails?.userType,
    })
  );
  // Inside your component
  const { settingsData, getSettingsLoading, userType } = useAppSelector(errorData);

  // get user settings
  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  const [settings, setSettings] = useState<SettingsTypes>(settingsData);
  useEffect(() => {
    setSettings(settingsData);
  }, [settingsData]);

  /*
  api calling
  */
  const onChangeData = (field: string, value: any) => {
    dispatch(updateSettings(field, value));
  };

  /*
  collapse handeling
  */
  const [selectedMenu, setSelectedMenu] = useState<
    | null
    | SETTINGS_COLLAPSES.DISPLAY
    | SETTINGS_COLLAPSES.PROFILE
    | SETTINGS_COLLAPSES.HELP
    | SETTINGS_COLLAPSES.PRIVACY
    | SETTINGS_COLLAPSES.SECURITY
    | SETTINGS_COLLAPSES.THEME
    | SETTINGS_COLLAPSES.SYSTEM
    | SETTINGS_COLLAPSES.NOTIFICATION_SETTING
    | SETTINGS_COLLAPSES.DATA
  >(null);

  const collapseItems: CollapseItemTypes[] = [
    {
      value: SETTINGS_COLLAPSES.DISPLAY,
      label: "การแสดงผล",
      icon: "bx bx-palette",
      component: <DisplaySetting basicDetails={settings.basicDetails} />,
    },

    {
      value: SETTINGS_COLLAPSES.NOTIFICATION_SETTING,
      label: userType == UserTypes.Employee ? "การแจ้งเตือน" : "",
      icon: "fas fa-bell",
      component: <NotificationSetting></NotificationSetting>,
    },

    {
      value: SETTINGS_COLLAPSES.DATA,
      label: userType == UserTypes.Employee ? "การจัดการข้อมูล" : "",
      icon: "fas fa-database",
      component: <DataSetting/>,
    },    
    
    {
      value: SETTINGS_COLLAPSES.SYSTEM,
      label: "ระบบ และสิทธิ์อุปกรณ์",
      icon: "bx bx-select-multiple",
      component: <SystemSetting></SystemSetting>,
    },

    // {
    //   value: SETTINGS_COLLAPSES.PROFILE,
    //   label: "Personal Info",
    //   icon: "bx bxs-user",
    //   component: <PersonalInfo basicDetails={settings.basicDetails} />,
    // },
    // {
    //   value: SETTINGS_COLLAPSES.THEME,
    //   label: "Themes",
    //   icon: "bx bxs-adjust-alt",
    //   component: (
    //     <ThemeSettings theme={settings.theme} onChangeData={onChangeData} />
    //   ),
    // },
    // {
    //   value: SETTINGS_COLLAPSES.PRIVACY,
    //   label: "Privacy",
    //   icon: "bx bxs-lock",
    //   component: (
    //     <Privacy privacy={settings.privacy} onChangeSettings={onChangeData} />
    //   ),
    // },
    // {
    //   value: SETTINGS_COLLAPSES.SECURITY,
    //   label: "Security",
    //   icon: "bx bxs-check-shield",
    //   component: (
    //     <Security
    //       security={settings.security}
    //       onChangeSettings={onChangeData}
    //     />
    //   ),
    // },
    // {
    //   value: SETTINGS_COLLAPSES.HELP,
    //   label: "Help",
    //   icon: "bx bxs-help-circle",
    //   component: <Help />,
    // },
  ];

  const onChangeCollapse = (
    id:
      | null
      | SETTINGS_COLLAPSES.DISPLAY
      | SETTINGS_COLLAPSES.PROFILE
      | SETTINGS_COLLAPSES.HELP
      | SETTINGS_COLLAPSES.PRIVACY
      | SETTINGS_COLLAPSES.SECURITY
      | SETTINGS_COLLAPSES.THEME
      | SETTINGS_COLLAPSES.SYSTEM
      | SETTINGS_COLLAPSES.NOTIFICATION_SETTING
      | SETTINGS_COLLAPSES.DATA
  ) => {
    if (id == SETTINGS_COLLAPSES.THEME) {
      alert('x');
    } else {
      setSelectedMenu(id);
    }
  };

  return (
    <div className="position-relative">
      {getSettingsLoading && <Loader />}
      <UserCoverImage basicDetails={settings.basicDetails} />

      {/* <UserProfile
        basicDetails={settings.basicDetails}
        status={settings.status}
      /> */}
      {/* Start User profile description */}
      <AppSimpleBar className="app-setting">
        <div id="settingprofile" className="accordion accordion-flush">
          {(collapseItems || []).filter(t => t.label ? true : false).map((item: CollapseItemTypes, key: number) => (
            <AccordianItem item={item} key={key} selectedMenu={selectedMenu} onChange={onChangeCollapse} />
          ))}
        </div>
        {/* end profile-setting-accordion */}
      </AppSimpleBar>
    </div>
  );
};

export default Index;
